import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Select } from "components/Select/Select";
import { useFormik } from "formik";
import { CicloI } from "interfaces/Ciclo";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createCicloSchema } from "schemas/ciclo/CreateCicloSchema";
import { postCiclo, putCiclo } from "services/ciclo";
import { RootState } from "store/store";
import { maxAnioCiclo, minAnioCiclo } from "../constants";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: CicloI;
  onSuccess?: (titulo: CicloI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  descripcion: string;
  anioInicial: string | number;
  anioFinal: string | number;
}

const makeAniosOptionsSelect = (
  minAnio: number,
  maxAnio: number,
  interval: number = 1,
) => {
  const options: { label: any; value: any }[] = [];

  for (let i = minAnio; i <= maxAnio; i += interval) {
    options.push({ value: i, label: i });
  }

  return options;
};

export const CicloABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const aniosOptions = makeAniosOptionsSelect(minAnioCiclo, maxAnioCiclo);

  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
    descripcion: "",
    anioInicial: 0,
    anioFinal: 0,
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        descripcion: elemento?.descripcion ?? "",
        anioInicial: elemento?.anioInicial ?? "",
        anioFinal: elemento?.anioFinal ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newCiclo = await postCiclo({ params });
      showSuccessToast("¡El ciclo fue creado con éxito!");
      if (onSuccess) onSuccess(newCiclo);
      onClose();
    } catch (err: any) {
      showErrorToast("El ciclo no pudo ser creado.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newCiclo = await putCiclo({ params });
      showSuccessToast("¡El ciclo fue editado con éxito!");
      if (onSuccess) onSuccess(newCiclo);
      onClose();
    } catch (err: any) {
      showErrorToast("El ciclo no pudo ser creado.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createCicloSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Ciclo" : "Nuevo Ciclo"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={6}>
                  <Input
                    id={"nombre"}
                    title="Nombre del ciclo"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6}>
                  <Input
                    id={"descripcion"}
                    title="Descripción"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col sm={6}>
                  <Select
                    id="anioInicial"
                    values={values}
                    errors={errors}
                    title="Año inicial"
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                    options={aniosOptions}
                    onChange={handleChange}
                    isSearchable={true}
                  />
                </Col>

                <Col sm={6}>
                  <Select
                    id="anioFinal"
                    values={values}
                    errors={errors}
                    title="Año Final"
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                    options={aniosOptions}
                    onChange={handleChange}
                    isSearchable={true}
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
